import React from 'react';
import PropTypes from 'prop-types';

import styles from './Footer.scss';

const Footer = ({ children, align }) => (
  <div className={styles.Footer}>
    <div className={`${styles['button-container']} ${align ? styles[align] : ''}`}>
      {children}
    </div>
  </div>
);

Footer.defaultProps = {
  children: null,
  align: ''
};

Footer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.node
  ]),
  align: PropTypes.string
};

export default Footer;



// WEBPACK FOOTER //
// ./src/containers/Footer/Footer.js